import { CommunicationRate } from "pages/home/components/CommunicationSection/CommunicationRateSection/components/CommunicationRate";
import { Column1, SectionTitle } from "pages/home/components/Layout";

export const CommunicationRateSection = ({
  filteredSuggests,
  filteredInquiries,
  suggestPer1,
  suggestPer,
  inquiriesPer1,
  inquiriesPer,
}) => {
  return (
    <Column1>
      <SectionTitle>건의/문의 처리율</SectionTitle>
      <CommunicationRate
        filteredSuggests={filteredSuggests}
        filteredInquiries={filteredInquiries}
        suggestPer1={suggestPer1}
        suggestPer={suggestPer}
        inquiriesPer1={inquiriesPer1}
        inquiriesPer={inquiriesPer}
      />
    </Column1>
  );
};
